export default __webpack_public_path__ + "static/media/example-xcz.02d5acbc.png";